import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, DestroyRef, effect, inject, INJECTOR, input, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatRippleModule } from '@angular/material/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { Subscription } from 'rxjs';
import { LeafItem } from '../../models';

@Component({
  selector: 'li[link-tree-leaf]',
  templateUrl: './leaf.component.html',
  styleUrl: './leaf.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    RouterModule,
    FontAwesomeModule,
    MatRippleModule
  ],
  host: {
    '[style.--depth]': 'depth()'
  },
  hostDirectives: [
    RouterLink,
    RouterLinkActive
  ]
})
export class LinkTreeLeafComponent implements OnInit {
  private readonly injector = inject(INJECTOR);
  private readonly routerLink = inject(RouterLink, { self: true });
  private readonly active = inject(RouterLinkActive, { self: true });
  private readonly dRef = inject(DestroyRef);
  readonly link = input.required<LeafItem>();
  readonly depth = input(0);

  readonly hasIcon = computed(() => {
    const item = this.link();
    return item.icons && item.icons.end;
  });

  ngOnInit(): void {
    this.active.routerLinkActive = ['active'];
    this.active.routerLinkActiveOptions = {
      exact: true
    };
    let activeSub: Subscription;

    effect(() => {
      const link = this.link();
      switch (true) {
        case 'href' in link: {
          this.routerLink.href = link.href;
        } break;
        case 'route' in link: {
          this.routerLink.routerLink = link.route;
          this.routerLink.ngOnChanges();
          activeSub?.unsubscribe();
          activeSub = this.active.isActiveChange
            .pipe(takeUntilDestroyed(this.dRef))
            .subscribe(event => {
              link.activated?.(event);
            });
        } break;
      }

    }, { injector: this.injector });
  }
}